import React from 'react'

export default function LeagueExtensionSection({
  extensionDays,
  setExtensionDays,
  handleExtendLeague,
  isExtendingLeague,
}) {
  return (
    <div className="form-section">
      <h3>League Extension</h3>
      <p className="text-muted">
        Extend the league timeline and notify all participants by email.
      </p>
      <div className="form-row align-items-end">
        <div className="form-group">
          <label htmlFor="extension_days">Extend by (days)</label>
          <input
            id="extension_days"
            name="extension_days"
            type="number"
            min="1"
            value={extensionDays}
            onChange={(e) => setExtensionDays(e.target.value)}
            data-testid="league-extension-days-input"
          />
        </div>
        <div className="form-group">
          <button
            type="button"
            className="btn btn-outline-primary"
            onClick={handleExtendLeague}
            disabled={isExtendingLeague}
            aria-busy={isExtendingLeague}
            data-testid="league-extension-submit-button"
          >
            {isExtendingLeague
              ? 'Extending...'
              : 'Extend League & Email Players'}
          </button>
        </div>
      </div>
    </div>
  )
}
